import React from "react";
import { Icon, } from "semantic-ui-react";

type showDocs = {
    onClickCallback: any,
    displayChildRecords: boolean,
    childRecords: any
}

function ExpandIcon({ childRecords, displayChildRecords, onClickCallback }: showDocs) {

    const toggleDisplay = () => {
        onClickCallback(!displayChildRecords);
    }

    if (childRecords > 0 && displayChildRecords === false) {
        return (
            <div style={{ display: "inline", cursor: 'pointer' }} onClick={() => toggleDisplay()}>
                <Icon name="plus square outline" color="grey" style={{ cursor: 'pointer' }} />
            </div>
        )
    }

    if (childRecords > 0 && displayChildRecords === true) {
        return (
            <div style={{ display: "inline", cursor:'pointer' }} onClick={() => toggleDisplay()}>
                <Icon name="minus square outline" color="grey" style={{ cursor: 'pointer' }} />
            </div>
        )

    }

    else return <></>;
}

export default ExpandIcon;